/**
 * BottomNav — mobile bottom navigation bar for client users
 */
import { NavLink } from 'react-router-dom';
import Icon from '../common/Icon';

const navItems = [
  { to: '/', label: 'Dashboard', icon: 'LayoutDashboard' },
  { to: '/my-programs', label: 'Programs', icon: 'BookOpen' },
  { to: '/connect', label: 'Connect', icon: 'MessageCircle' },
  { to: '/shop', label: 'Shop', icon: 'ShoppingCart' },
];

const BottomNav = () => {
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      <div className="bottom-nav__inner">
      {navItems.map(({ to, label, icon }) => (
        <NavLink
          key={to}
          to={to}
          data-nav-direction="lateral"
          className={({ isActive }) =>
            `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`
          }
          end={to === '/'}
        >
          <Icon name={icon} size={20} className="bottom-nav__icon" aria-hidden="true" />
          <span className="bottom-nav__label">{label}</span>
        </NavLink>
      ))}
      </div>
    </nav>
  );
};

export default BottomNav;
